exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mkt-hero {\n  position: relative;\n  z-index: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/hero/mkt-hero/mkt-hero.component.scss
// module id = ../../../../../src/app/hero/mkt-hero/mkt-hero.component.scss
// module chunks = main